<script lang="ts">
  import { getStr } from '../../../../../common/util';
  import Text from '../../Text.svelte';
  export let dividerFlag = false;
  export let showLabel = false;
  let LogoUrl = getStr('extra.marketplace.online.only.icon.url');
</script>

{#if showLabel}
  <div class="online-only-badge" class:divider={dividerFlag}>
    <img class="logo" src={LogoUrl} alt="onlineLabelLogo" />
    <span>
      <Text key="extra.marketplace.online.only.label" />
    </span>
  </div>
{/if}

<style lang="scss">
  @import '../../../../common/styles/colors.new.scss';
  .online-only-badge {
    display: flex;
    align-items: center;
    gap: 4px;
    .logo {
      width: 16px;
      height: 16px;
    }
    &.divider {
      border-left: 2px solid $neutral-dark-03;
      padding-left: 5px;
      margin-left: 6px;
    }
    span {
      font-size: 14px;
      line-height: 16px;
      font-weight: 500;
      color: $neutral-dark-03;
    }
  }
</style>
